import React, {Component} from 'react'
import {connect} from 'react-redux'
import {toast} from 'react-toastify';
import ToastMessage from '../common/toast-message';
import Error from './error';
import {Redirect} from "react-router-dom";

class FailedSso extends Component {
  componentDidMount() {
    toast.error(<ToastMessage
      iconStyle="error"
      message={(<Error />)}
     />);
  }

  render() {
    return (
      <Redirect to="/"/>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    samlResponse: state.saml.samlResponse
  };
};

export default connect(mapStateToProps)(FailedSso);



// WEBPACK FOOTER //
// ./src/components/elearning/failed_sso.jsx